import React, { useEffect, useState } from "react";
import {
  Box,
  Chip,
  IconButton,
  TextField,
  InputAdornment,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TableContainer,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useParams } from "react-router-dom";
import ClearIcon from "@mui/icons-material/ClearOutlined";
import { IoIosSearch } from "react-icons/io";
import { useGetAllSubmitBOQQuery } from "store/slices/apis/keyBOQSlice";

const StyledTableCell = (props) => (
  <TableCell
    {...props}
    sx={{
      whiteSpace: "nowrap",
      border: "1px solid #ccc",
      textAlign: "center",
      ...props.sx,
    }}
  />
);

const SubmittedBOQ = () => {
  const theme = useTheme();
  const { projectId } = useParams();
  const [searchQuery, setSearchQuery] = useState("");
  const [tableData, setTableData] = useState([]);

  const { data: allBOQ, refetch } = useGetAllSubmitBOQQuery({
    projectId: projectId,
  });

  useEffect(() => {
    refetch();
  }, []);

  useEffect(() => {
    if (allBOQ?.data?.items) {
      setTableData(allBOQ.data.items);
    }
  }, [allBOQ]);

  const clearSearch = () => setSearchQuery("");

  const handleSearchChange = (e) => setSearchQuery(e.target.value);

  const filteredData = tableData.filter((row) =>
    (row.subCategory1 || "").toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <Box sx={{ mt: 4 }}>
      <Typography sx={{ fontWeight: 700, fontSize: "20px" }}>BOQ List</Typography>

      <Box sx={{ display: "flex", justifyContent: "start", mt: 2 }}>
        <TextField
          value={searchQuery}
          onChange={handleSearchChange}
          placeholder="Search by Sub Category"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <IoIosSearch />
              </InputAdornment>
            ),
            endAdornment: searchQuery && (
              <IconButton onClick={clearSearch} edge="end">
                <ClearIcon style={{ fontSize: "16px" }} />
              </IconButton>
            ),
          }}
          sx={{ width: "400px", backgroundColor: "#fff" }}
          size="small"
        />
      </Box>

      <TableContainer component={Paper} sx={{ mt: 4 }}>
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCell>BOQ ID</StyledTableCell>
              <StyledTableCell>Sub Category1</StyledTableCell>
              <StyledTableCell>Sub Category2</StyledTableCell>
              <StyledTableCell>Sub Category3</StyledTableCell>
              <StyledTableCell>Rate</StyledTableCell>
              <StyledTableCell>Quantity</StyledTableCell>
              <StyledTableCell>Total Cost</StyledTableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {filteredData.length === 0 ? (
              <TableRow>
                <StyledTableCell colSpan={7}>No data available</StyledTableCell>
              </TableRow>
            ) : (
              filteredData.map((row, index) => (
                <TableRow key={index}>
                  <StyledTableCell>
                    <Chip label={row?.boQ_Alias} size="small" />
                  </StyledTableCell>
                  <StyledTableCell>{row.subCategory1}</StyledTableCell>
                  <StyledTableCell>{row.subCategory2}</StyledTableCell>
                  <StyledTableCell>{row.subCategory3}</StyledTableCell>
                  <StyledTableCell>{row.rate}</StyledTableCell>
                  <StyledTableCell>{row.quantity}</StyledTableCell>
                  <StyledTableCell>{row.totalCost}</StyledTableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default SubmittedBOQ;
